import services from "@/assets/services-new"
import json from "@/assets/ballpark680.js"
import { Config } from '@/services/api'
import {SAVE_PLATFORMS, SELECTED_FILE} from "@/store/keys"

export default {
  state: {
    approvalSelected: false,
    selectedApproval: null,
    selectedJsonConfig: json,
    selectedJsonUpdates: null,
    selectedMajorVersion: null,
    selectedMinorVersion: null,
    selectedPlatform: "iOS",
    selectedVersion: null,
    services: services,
    versionSelected: false,
    platforms: [],
    selectedConfig: {},
    selectedFile: null,
  },
  getters: {
    approvalSelected: state => state.approvalSelected,
    selectedApproval: state => state.selectedApproval,
    selectedJsonConfig: state => state.selectedJsonConfig,
    selectedJsonUpdates: state => state.selectedJsonUpdates,
    selectedMajorVersion: state => state.selectedMajorVersion,
    selectedMinorVersion: state => state.selectedMinorVersion,
    selectedVersion: state => state.selectedVersion,
    services: state => state.services,
    versionSelected: state => state.versionSelected,
    platforms: state => state.platforms,
    selectedConfig: state => state.selectedConfig,
    selectedFile: state => state.selectedFile,
  },
  mutations: {
    selectApprovalVersion(state, payload) {
      state.selectedApproval = payload
      state.approvalSelected = true
    },
    selectPlatform(state, platform) {
      state.selectedPlatform = platform
    },
    selectVersions(state, payload) {
      state.selectedMajorVersion = payload.major
      state.selectedMinorVersion = payload.minor
      state.selectedVersion = payload.selected
      state.versionSelected = true
    },
    saveJsonDiff(state, diffData) {
      state.selectedJsonUpdates = diffData
    },
    [SAVE_PLATFORMS] (state, platforms) {
      state.platforms = platforms
    },
    [SELECTED_FILE] (state, file) {
      state.selectedFile = file
    },
  },
  actions: {
    async retrievePlatforms({ commit }) {
      const platforms = await Config.platforms()
      commit(SAVE_PLATFORMS, platforms)
    },
  },
}